import cx from "classnames";
import styles from "./index.module.scss";

export default ({ className, ...rest }) => (
  <svg {...rest} className={cx(styles.main, className)} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_22654_91461)">
      <path
        d="M13.9806 1.74732L12.2333 0L6.99032 5.24265L1.7479 0L0 1.74732L5.24312 6.99008L0 12.2327L1.7479 13.9801L6.99032 8.7374L12.2333 13.9801L13.9806 12.2327L8.73822 6.99008L13.9806 1.74732Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
